import type { SVGProps } from 'react';

interface LeadStatusIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function LeadStatusIcon({ className, ...props }: LeadStatusIconProps) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle
        cx="6"
        cy="6"
        r="5.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="2 2.13"
      />
    </svg>
  );
}
